//hook
import { useApi } from "../../hooks/useApi";
import { useEffect, useState } from "react"

//mui
import Box from '@mui/material/Box';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import Typography from '@mui/material/Typography';
import { CardActionArea, CardMedia, CircularProgress, Dialog, DialogContent, DialogProps, IconButton } from "@mui/material";

//mui icon
import ReplayIcon from '@mui/icons-material/Replay';
import ReportGmailerrorredIcon from '@mui/icons-material/ReportGmailerrorred';
import CloseIcon from '@mui/icons-material/Close';
import KeyboardTabIcon from '@mui/icons-material/KeyboardTab';
import EmojiFlagsIcon from '@mui/icons-material/EmojiFlags';
import LocationOnOutlinedIcon from '@mui/icons-material/LocationOnOutlined';
import CalendarTodayIcon from '@mui/icons-material/CalendarToday';
import QueryBuilderIcon from '@mui/icons-material/QueryBuilder';
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
import WatchLaterIcon from '@mui/icons-material/WatchLater';
import ColorLensIcon from '@mui/icons-material/ColorLens';
import ConfirmationNumberIcon from '@mui/icons-material/ConfirmationNumber';

//api
import { UpdateClaimApi } from "../../api/Host/UpdateClaimApi";
import { GetMyClaimsApi } from "../../api/Host/GetMyClaimsApi";

//type
import { Claim } from "../../api/Host/type/ClaimsType";

//translate
import { useTranslation } from "react-i18next";
import i18n from "../../translate/i18n";

//component
import ClaimCard from "../../component/cliams/ClaimCard";
import NoData from "../../component/NoData";
import AddClaims from "../../component/cliams/AddClaims";
import TimeAndHourBooking from "../../component/TimeAndHourBooking";

//image
import claimPlaceHolder from "../../assets/claimPlaceHolder.png"

//swiper
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Pagination } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';

//css file
import styles from "../../popup/carDetails/CarDetails.module.css"

//utilis
import { formatDateTimeUTC } from "../../utils/formatDateTime";

const storageURL = process.env.REACT_APP_STORAGE_BASE_URL;


const MyClaims = () => {
  const { t } = useTranslation();
  const {
  loading: getClaimsLoading,
  error: getClaimsError,
  HandlerApi: getClaims
  } = useApi(GetMyClaimsApi, "GET");
  const {
  loading: updateClaimLoading,
  error: updateClaimError,
  HandlerApi: updateClaim
  } = useApi(UpdateClaimApi, "Post");
  let [claimsData, setClaimsData] = useState<Claim[]>([]);
  const [openUpdateClaimDilaog, setOpenUpdateClaimDilaog] = useState<{open:boolean,scrollType: DialogProps['scroll']}>({
    open:false,
    scrollType: "paper",
  });
  const [selectedClaim, setSelectedClaim] = useState<Claim | null>(null);
  const [selectedButton, setSelectedButton] = useState<string>("");
  useEffect(() => {
    const fetchData = async () => {
      let result = await getClaims();
      setClaimsData(result.data);
    }
    fetchData();
  },[])

  //start functions

  const handleCloseDilaogUpdateClaim = () => {
    setSelectedClaim(null);
    setSelectedButton("");
    setOpenUpdateClaimDilaog({open:false,scrollType: "paper"})
  };

  //end functions

  return (
  <div>
    <Card className="!bg-paretnerColor !text-white mb-5">
      <CardContent className="!flex items-center gap-5">
        <Typography gutterBottom sx={{ color: 'text.secondary', fontSize: 14 }}>
          <ReportGmailerrorredIcon className="!text-white !text-[50px]"/>
        </Typography>
        <div>
          <Typography variant="h5" component="div">
            {t("claims_count")}
          </Typography>
          <Typography variant="body2">
            {getClaimsLoading ? 0 : claimsData?.length} - {t("claim")}
          </Typography>
        </div>
      </CardContent>
    </Card>
    <div>
      {
        getClaimsLoading
        ?
          <div className='flex justify-center'>
            <CircularProgress/>
          </div>
        : getClaimsError
          ?
            <div className='cursor-pointer flex justify-center'>
              <ReplayIcon onClick={()=>{getClaims()}} className='!text-[40px]'/>
            </div>
          :
            claimsData.length === 0
            ? <NoData title={t("claims")} description={t("you_don't_have_any_cliams_yet")} image={claimPlaceHolder}/>
            :
            <Box
              sx={{
                width: '100%',
                display: 'grid',
                gridTemplateColumns: 'repeat(auto-fill, minmax(270px, 1fr))',
                gap: 2,
              }}
            >
              {
                claimsData.map((element, index) => (
                  <ClaimCard key={index} element={element} setOpenUpdateClaimDilaog={setOpenUpdateClaimDilaog} setSelectedClaim={setSelectedClaim} setSelectedButton={setSelectedButton}/>
                ))
              }
            </Box>
      }
    </div>
    <Dialog 
    open={openUpdateClaimDilaog.open}
    onClose={handleCloseDilaogUpdateClaim}
    disableRestoreFocus
    maxWidth="sm"
    fullWidth 
    >
      <DialogContent className={`${selectedButton === "view" ? "!p-0" : ""}`} dividers={openUpdateClaimDilaog.scrollType === 'paper'}>
        {selectedButton === "edit" 
        ? 
          <AddClaims 
          callFunction={updateClaim}
          loading={updateClaimLoading}
          setCloseDialog={setOpenUpdateClaimDilaog}
          reCallfetchApi={getClaims}
          setData={setClaimsData}
          claim_id={selectedClaim?.id}
          comment={selectedClaim?.comment}
          />
        :
                <div>
                    <div className='relative overflow-hidden'>
                        <div className={`flex justify-end absolute px-3 top-3 z-10`}>
                            <IconButton
                            className={`${selectedClaim?.booking.car.fuel_type=== "electric" ? "!bg-electricColor" :"!bg-paretnerColor"} !rounded-md max-sm:!w-[30px] max-sm:!h-[30px]`}
                            onClick={handleCloseDilaogUpdateClaim}
                            size="large"
                            >
                                <CloseIcon className='!text-white'/>
                            </IconButton>
                        </div>
                        <span className={`absolute sm:top-64 top-40 px-3 py-1 z-10 ${i18n.language === "en" ? "right-3" : "left-3"} rounded-lg text-white text-sm font-semibold bg-orange-600`}>
                            {t(`${selectedClaim?.booking.current_status}`)}
                        </span>
                        <div>
                            <div>
                                <CardActionArea className={` ${i18n.language === "en" ? `ltrSwiper ${styles.ltrSwiper}` : `rtlSwiper ${styles.rtlSwiper}`}`}>
                                    <Swiper
                                    key={i18n.language}
                                    dir={i18n.language === "ar" ? "rtl" : "ltr"}
                                    loop={true}
                                    spaceBetween={30}
                                    navigation
                                    pagination={{ clickable: true }}
                                    modules={[Navigation, Pagination]}
                                    className={`carCardDetailsSwiper ${styles.carCardDetailsSwiper} ${selectedClaim?.booking.car.fuel_type === "electric" ? `electricSwiper ${styles.electricSwiper}` : `paretnerSwiper ${styles.paretnerSwiper}`}`}
                                >
                                    {selectedClaim?.booking.car?.primary_images.map((img, index) => (
                                    <SwiperSlide
                                    className="
                                    !flex 
                                    justify-center 
                                    items-center 
                                    sm:!h-[300px] max-sm:!h-[200px]
                                    "
                                    key={index}
                                    >
                                        <CardMedia
                                        component="img"
                                        src={`${storageURL}/${img.url}`}
                                        className='!h-full'
                                        alt="no_photo"
                                        />
                                    </SwiperSlide>
                                    ))}
                                    </Swiper>
                                </CardActionArea>
                            </div>
                        </div>
                    </div>
                    <div className="flex justify-center items-center gap-10 mt-3">
                        <div className='flex items-center'>
                            <LocationOnOutlinedIcon className={selectedClaim?.booking.car.fuel_type === "electric" ? "!text-electricColor" : "!text-paretnerColor"}/>
                            <span className="ml-1">{selectedClaim?.booking.location_in}</span>
                        </div>
                        <div>
                            {i18n.language === "en" ? <KeyboardTabIcon/> : <KeyboardTabIcon className='rotate-180'/>}
                        </div>
                        <div className='flex items-center'>
                            <EmojiFlagsIcon className='!text-red-500'/>
                            <span className="ml-1">{selectedClaim?.booking.location_out}</span>
                        </div>
                    </div>
                    <div className='px-3 mt-7'>
                        <div>
                          <p className='text-darkColor font-[800] sm:text-xl max-sm:text-sm mb-3'>{t("reservations_schedule")}</p> 
                          <div className='flex flex-wrap justify-between gap-3 rounded-2xl border p-3 border-gray-300 overflow-hidden shadow-lg hover:shadow-xl transition-shadow duration-300'>
                              <div className='flex flex-col gap-3'>
                                  <TimeAndHourBooking
                                  title={t("checkin_date")}
                                  value={`${formatDateTimeUTC(selectedClaim?.booking?.check_in_at || "").date}`}
                                  icon={<CalendarTodayIcon/>}
                                  type = {selectedClaim?.booking?.car.fuel_type}
                                  />  
                                  <TimeAndHourBooking
                                  title={t("checkout_date")}
                                  value={`${formatDateTimeUTC(selectedClaim?.booking?.check_out_at || "").date}`}
                                  icon={<CalendarMonthIcon/>}
                                  type = {selectedClaim?.booking?.car.fuel_type}
                                  />  
                              </div>
                              <div className='flex flex-col gap-3'>
                                  <TimeAndHourBooking
                                  title={t("checkin_time")}
                                  value={`${formatDateTimeUTC(selectedClaim?.booking?.check_in_at || "").time}`}
                                  icon={<QueryBuilderIcon/>}
                                  type = {selectedClaim?.booking?.car.fuel_type}
                                  />  
                                  <TimeAndHourBooking
                                  title={t("checkout_time")}
                                  value={`${formatDateTimeUTC(selectedClaim?.booking?.check_out_at || "").time}`}
                                  icon={<WatchLaterIcon/>}
                                  type = {selectedClaim?.booking?.car.fuel_type}
                                  />  
                              </div>
                          </div>
                        </div>
                        <div className='mt-3'>
                          <p className='text-darkColor font-[800] sm:text-xl max-sm:text-sm mb-3'>{t("car_info")}</p> 
                          <div className='flex justify-between gap-3 rounded-2xl border p-3 border-gray-300 overflow-hidden shadow-lg hover:shadow-xl transition-shadow duration-300'>
                              <TimeAndHourBooking
                              title={t("color")}
                              value={selectedClaim?.booking?.car.color || ""}
                              icon={<ColorLensIcon/>}
                              type = {selectedClaim?.booking?.car.fuel_type}
                              />  
                              <TimeAndHourBooking
                              title={t("is_confirmed")}
                              value={selectedClaim?.booking?.is_confirmed === 1 ? t("yes") : t("no")}
                              icon={<ConfirmationNumberIcon/>}
                              type = {selectedClaim?.booking?.car.fuel_type}
                              />
                          </div>
                        </div>
                    </div>
                </div>
        }
      </DialogContent>
    </Dialog>
  </div>
  )
}

export default MyClaims